/** @format */

import React, { useState } from "react";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import StepMaster from "./step-master";
import AopSites from "./aop-sites";
import ReportConfigSetup from "./report-config";
import ExceptionApproversSetup from "./exception-approvers";
import ApiClients from "./api-clients";
import CapexMasterData from "../capex-calculator/capex-master-data";
import { storeTypes } from "../../utils/constants";

function TabPanel({ children, value, index }) {
  return (
    <div hidden={value !== index}>
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

const Setup = () => {
  const [value, setValue] = useState(0);

  return (
    <Box sx={{ width: "100%" }}>
      <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
        <Tabs value={value} onChange={(_, v) => setValue(v)}>
          <Tab label="Coco Build Steps" />
          <Tab label="COCO Acquire Step" />
          <Tab label="AOP Sites" />
          <Tab label="Report Config" />
          <Tab label="Exception Approvers" />
          <Tab label="API Clients" />
          <Tab label="Capex Calculator" />
        </Tabs>
      </Box>
      <TabPanel value={value} index={0}>
        <StepMaster storeType={storeTypes.cocoBuild} />
      </TabPanel>
      <TabPanel value={value} index={1}>
        <StepMaster storeType={storeTypes.cocoAcquired} />
      </TabPanel>
      <TabPanel value={value} index={2}>
        <AopSites />
      </TabPanel>
      <TabPanel value={value} index={3}>
        <ReportConfigSetup />
      </TabPanel>
      <TabPanel value={value} index={4}>
        <ExceptionApproversSetup />
      </TabPanel>
      <TabPanel value={value} index={5}>
        <ApiClients />
      </TabPanel>
      <TabPanel value={value} index={6}>
        <CapexMasterData />
      </TabPanel>
    </Box>
  );
};

export default Setup;
